import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { DialogBaseComponent } from '../../dialog/dialog-base/dialog-base.component';

@Component({
    selector: 'app-source-citation-main',
    templateUrl: './source-citation-main.component.html',
    styleUrls: ['./source-citation-main.component.scss'],
    standalone: false
})
export class SourceCitationMainComponent extends DialogBaseComponent implements OnInit {

  viewMode : number = 2;
  data : any;
  constructor(private ds:DialogService, private ref1:ChangeDetectorRef) {
    super(ds, ref1);
  }

  ngOnInit(): void {
  }


}
